<app-operaciones-usuarios [titulo]="titulo" [usuarios]="usuariosAActivar" (funcion)="activarUsuarios($event)"
    (refresh)="refresh()" botonPrimario="Activar usuarios">
</app-operaciones-usuarios>